import { Assessment, AssessmentVersion, AxiosArgs, ProjectionVariant, ThenArgs } from 'src/api/types';
import axios, { AxiosResponse } from 'axios';
import { encodeBody, encodeQueryParams } from 'src/api/client';
import { QueryKey } from 'react-query';

type GetAssessment = (
  key: QueryKey,
  parameters: {
    assessmentId: string | number;
    version?: string;
    variant?: ProjectionVariant;
  },
) => Promise<AxiosArgs<ThenArgs<AxiosResponse<Assessment>>>>;

export const getAssessment: GetAssessment = (_, { assessmentId, ...params }) => {
  const path = `/api/public/api/assessments/${assessmentId}${encodeQueryParams({ ...params })}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};

// ------------------------------------------------------------

type GetAssessmentVersions = (
  a: string,
) => Promise<AxiosArgs<ThenArgs<AxiosResponse<{ assessmentId: string; versions: AssessmentVersion[] }>>>>;

export const getAssessmentVersions: GetAssessmentVersions = (assessmentId) => {
  const path = `/api/public/api/assessments/${assessmentId}/versions`;

  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};
// ------------------------------------------------------------

type PublishAssessmentVersion = (a: {
  assessmentId: string;
  name: string;
}) => Promise<AxiosArgs<ThenArgs<AxiosResponse<any[]>>>>;

export const publishAssessmentVersion: PublishAssessmentVersion = ({ assessmentId, ...params }) => {
  const path = `/api/public/api/assessments/${assessmentId}/versions`;

  return axios({
    method: 'POST',
    url: path,
    data: encodeBody(params),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};

// ------------------------------------------------------------

type DuplicateAssessmentFromVersion = (params: {
  id: string;
  incidents: {
    include: boolean;
    makeNewLink: boolean;
  };
  risk_management_plan: {
    include: boolean;
    makeNewLink: boolean;
  };
}) => Promise<AxiosArgs<ThenArgs<AxiosResponse<Assessment>>>>;

export const duplicateAssessmentFromVersion: DuplicateAssessmentFromVersion = (params) => {
  const path = `/api/public/api/assessments/versions/${params.id}`;

  return axios({
    method: 'POST',
    url: path,
    data: {
      incidents: {
        include: params.incidents.include,
        makeNewLink: params.incidents.makeNewLink,
      },
      risk_management_plan: {
        include: params.risk_management_plan.include,
        makeNewLink: params.risk_management_plan.makeNewLink,
      },
    },
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data);
};
